import { render, staticRenderFns } from "./LocalPostcode.vue?vue&type=template&id=b7263e86&"
import script from "./LocalPostcode.vue?vue&type=script&lang=js&"
export * from "./LocalPostcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports